import {
  after,
} from 'xe-utils';
import BasePage from '../../../../../../components/table_page';
// import {
//   ProcessLog,
// } from '../../../../../../modules';
import Form from '../form';
import request from '../../../../../../utils/request';
import ScanRecord from '../form/detail.vue';

export default {
  name: 'group_purchase_outbound_reporting',
  extends: BasePage,
  data() {
    return {
      params: {},
      tableData: [1],
    };
  },
  components: {
    Form,
    // ProcessLog,
    ScanRecord,
  },
  created() {
    this.getConfigList('main_list');
  },
  methods: {
    // 控制按钮显示
    clickVisible({
      row,
      val: {
        code,
      },
    }) {
      const {
        approveStatus,
        // processCode,
      } = row;
      //   // 审批通过 approved,审批中 approving,活动关闭 closed,流程追回 interrupt,驳回 rejected
      //   if (code === 'process_log' && !processCode) {
      //     return false;
      //   }
      if (
        code === 'edit'
        && approveStatus === 'Y'
      ) {
        return false;
      }
      //   if (
      //     approveStatus &&
      //     code === 'submit_approval' &&
      //     (approveStatus === '1' ||
      //       approveStatus === '2')
      //   ) {
      //     return false;
      //   }
      return true;
    },

    modalClick({
      val,
      row,
    }) {
      const {
        code,
      } = val;
      if (code === 'add' || code === 'edit' || code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code,
          row,
        };
        this.modalConfig.title = val.name || '查看';
        this.openFull();
      } else if (code === 'scan_code_record') {
        this.formConfig = {
          ...this.formConfig,
          reportRecordCode: row.reportRecordCode,
        };

        this.modalConfig.title = '扫码记录';
        this.formName = 'ScanRecord';
        this.openFull();
      }
      // else if (code === 'submit_approval') {
      //   request.get('/cps/v1/groupBuyingOutboundPerformance/findById', {
      //     id: row.id,
      //   })
      //     .then((res) => {
      //       if (res.success) {
      //         const rowData = {
      //           ...res.result,
      //           isSubmit: 'Y',
      //         };
      //         this.onSubmit({
      //           row: rowData,
      //           submitUrl: '/cps/v1/groupBuyingOutboundPerformance/update',
      //         });
      //       }
      //     });
      // }
      // else if (code === 'process_log') {
      //   this.formConfig = {
      //     ...this.formConfig,
      //     code,
      //     row: {
      //       processNo: row.processCode,
      //     },
      //   };

      //   this.modalConfig.title = '流程日志';

      //   this.formName = 'ProcessLog';
      //   this.openDrawer();
      // }
    },

    // 提交审批回调
    // onSubmit(params) {
    //   const configParams = {
    //     ...params,
    //     code: 'approve',
    //     // data: 'activity',
    //   };

    //   this.$emit('approve', configParams);
    // },
  },
};
